import { makeStyles, TextField, Typography } from '@material-ui/core';
import React, { FC, useState, useRef, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { ModalConsumer } from 'components/modal/hooks/useModal';
import CartCustomerActions from './OrderCustomerActions';
import Modal from 'components/modal/Modal';
import { setOrderCustomerName } from 'store/redux/modules/order/actions';
import { useOrder } from '../../hooks/useOrder';

const styles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    gap: 20,
  },
});

interface CartCustomerProps {
  onExited(): void;
}

const CartCustomer: FC<CartCustomerProps> = ({ onExited }) => {
  const classes = styles();
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const input = useRef<HTMLInputElement>(null);
  const { handleSubmit } = useOrder();

  function handleConfirm(closeDialog: () => void, event?: FormEvent<HTMLFormElement>) {
    event?.preventDefault();

    setError('');

    if (!name) {
      setError('O nome é obrigatório');
      throw new Error('O nome é obrigatório');
    }

    dispatch(setOrderCustomerName(name));

    closeDialog();

    handleSubmit(name);
  }

  return (
    <Modal
      maxWidth="sm"
      onExited={onExited}
      title="nome do cliente"
      componentActions={<CartCustomerActions handleConfirm={handleConfirm} />}
    >
      <ModalConsumer>
        {context => (
          <form onSubmit={event => handleConfirm(context.handleModalClose, event)}>
            <div className={classes.container}>
              <Typography variant="body1">Para continuar por favor informe o nome do cliente</Typography>
              <TextField
                inputRef={input}
                label="Nome do cliente"
                placeholder="Informe o nome do cliente"
                margin="normal"
                value={name}
                onChange={event => setName(event.target.value)}
                fullWidth
                autoFocus
                error={!!error}
                helperText={error}
              />
              <button type="submit" style={{ display: 'none' }} />
            </div>
          </form>
        )}
      </ModalConsumer>
    </Modal>
  );
};

export default CartCustomer;
